import { Box } from "@modernatx-internal/component-library";
import React from "react";

import { useMapContext } from "@/finder/googleMaps/GoogleMapsProvider";

interface MapProps extends google.maps.MapOptions {
  children?: React.ReactNode;
  hidden?: boolean;
}

export const Map: React.FC<MapProps> = ({ children, hidden }: MapProps) => {
  const { mapRef, map } = useMapContext();

  return (
    <Box
      ref={mapRef}
      data-track="finder-map"
      sx={{
        width: "100%",
        minHeight: hidden ? 0 : [63, null, 150],
        display: hidden ? "none" : "initial",
        flexGrow: 1
      }}
    >
      {!!map && children}
    </Box>
  );
};
